// extracted by mini-css-extract-plugin
module.exports = {"SimpleHeader":"SimpleHeader_SimpleHeader__5JEg5"};